export const aratiData = {
  ganesh: {
    name: "Lord Ganesha",
    image: "/lyrics/ganesh_ji.png",

    aratis: [
      {
        id: "jai-ganesh",
        title: "Shree Ganesh",
        lyrics: {
          hi: [
            "॥ श्री गणेशजी की आरती ॥",
            "जय गणेश, जय गणेश, जय गणेश देवा।",
            "माता जाकी पार्वती, पिता महादेवा॥ (x2)",
            "एकदन्त दयावन्त, चार भुजाधारी।",
            "माथे पर तिलक सोहे, मूसे की सवारी॥ (x2)",
            "(माथे पर सिन्दूर सोहे, मूसे की सवारी॥)",
            "पान चढ़े फूल चढ़े, और चढ़े मेवा।",
            "(हार चढ़े फूल चढ़े, और चढ़े मेवा।)",
            "लड्डुअन का भोग लगे, सन्त करें सेवा॥ (x2)",
            "जय गणेश, जय गणेश, जय गणेश देवा।",
            "माता जाकी पार्वती, पिता महादेवा॥ (x2)"
          ],

          en: [
            "॥ Shri Ganeshaji Ki Aarti ॥",
            "Jaya Ganesha, Jaya Ganesha, Jaya Ganesha Deva.",
            "Mata Jaki Parvati, Pita Mahadeva. (x2)",
            "Ekadanta Dayavanta, Chara Bhujadhari.",
            "Mathe Para Tilaka Sohe, Muse Ki Savari. (x2)",
            "(Mathe Para Sindura Sohe, Muse Ki Savari.)",
            "Pana Chadhe, Phula Chadhe, Aura Chadhe Meva.",
            "(Hara Chadhe, Phula Chadhe, Aura Chadhe Meva.)",
            "Ladduana Ka Bhoga Lage, Santa Karein Seva. (x2)",
            "Jaya Ganesha, Jaya Ganesha, Jaya Ganesha Deva.",
            "Mata Jaki Parvati, Pita Mahadeva. (x2)"
          ],

          bn: [
            "॥ শ্ৰী গণেশজী কী আৰতী ॥",
            "জয় গণেশ, জয় গণেশ, জয় গণেশ দেৱা।",
            "মাতা জাকী পাৰ্ৱতী, পিতা মহাদেৱা॥ (x2)",
            "একদন্ত দয়াৱন্ত, চাৰ ভুজাধাৰী।",
            "মাথে পৰ তিলক সোহে, মূসে কী সৱাৰী॥ (x2)",
            "(মাথে পৰ সিন্দূৰ সোহে, মূসে কী সৱাৰী॥)",
            "পান চঢ়ে, ফূল চঢ়ে, ঔৰ চঢ়ে মেৱা।",
            "(হাৰ চঢ়ে, ফূল চঢ়ে, ঔৰ চঢ়ে মেৱা।)",
            "লড্ডুঅন কা ভোগ লগে, সন্ত কৰেং সেৱা॥ (x2)",
            "জয় গণেশ, জয় গণেশ, জয় গণেশ দেৱা।",
            "মাতা জাকী পাৰ্ৱতী, পিতা মহাদেৱা॥ (x2)"
          ]
        }
      },
      {
        id: "jai-ganesh1",
        title: "Vinayaka",
        lyrics: {
          hi: [
            "॥ आरती गजबदन विनायक की ॥",
            "आरती गजबदन विनायक की। सुर-मुनि-पूजित गणनायक की॥",
            "आरती गजबदन विनायक की। सुर-मुनि-पूजित गणनायक की॥",
            "आरती गजबदन विनायक की॥",

            "एकदन्त शशिभाल गजानन, विघ्नविनाशक शुभगुण कानन।",
            "शिवसुत वन्द्यमान-चतुरानन, दुःखविनाशक सुखदायक की॥",
            "आरती गजबदन विनायक की॥",

            "ऋद्धि-सिद्धि-स्वामी समर्थ अति, विमल बुद्धि दाता सुविमल-मति।",
            "अघ-वन-दहन अमल अबिगत गति, विद्या-विनय-विभव-दायककी॥",
            "आरती गजबदन विनायक की॥",

            "पिङ्गलनयन, विशाल शुण्डधर,",
            "धूम्रवर्ण शुचि वज्रांकुश-कर।",
            "लम्बोदर बाधा-विपत्ति-हर, सुर-वन्दित सब विधि लायक की॥",
            "आरती गजबदन विनायक की॥"
          ],

          en: [
            "॥ Aarti Gajabadana Vinayaka Ki ॥",
            "Aarti Gajabadana Vinayaka Ki। Sura-Muni-Pujita Gananayaka Ki॥",
            "Aarti Gajabadana Vinayaka Ki। Sura-Muni-Pujita Gananayaka Ki॥",
            "Aarti Gajabadana Vinayaka Ki॥",

            "Ekadanta Shashibhala Gajanana, Vighnavinashaka Shubhaguna Kanana।",
            "Shivasuta Vandyamana-Chaturanana, Duhkhavinashaka Sukhadayaka Ki॥",
            "Aarti Gajabadana Vinayaka Ki॥",

            "Riddhi-Siddhi-Svami Samartha Ati, Vimala Buddhi Data Suvimala-Mati।",
            "Agha-Vana-Dahana Amala Abigata Gati, Vidya-Vinaya-Vibhava-Dayakaki॥",
            "Aarti Gajabadana Vinayaka Ki॥",

            "Pingalanayana, Vishala Shundadhara,",
            "Dhumravarna Shuchi Vajrankusha-Kara।",
            "Lambodara Badha-Vipatti-Hara, Sura-Vandita Saba Vidhi Layaka Ki॥",
            "Aarti Gajabadana Vinayaka Ki॥"
          ],

          bn: [
            "॥ আৰতী গজবদন ৱিনায়ক কী ॥",
            "আৰতী গজবদন ৱিনায়ক কী। সুৰ-মুনি-পূজিত গণনায়ক কী॥",
            "আৰতী গজবদন ৱিনায়ক কী। সুৰ-মুনি-পূজিত গণনায়ক কী॥",
            "আৰতী গজবদন ৱিনায়ক কী॥",

            "একদন্ত শশিভাল গজানন, ৱিঘ্নৱিনাশক শুভগুণ কানন।",
            "শিৱসুত ৱন্দ্যমান-চতুৰানন, দুঃখৱিনাশক সুখদায়ক কী॥",
            "আৰতী গজবদন ৱিনায়ক কী॥",

            "ঋদ্ধি-সিদ্ধি-স্ৱামী সমৰ্থ অতি, ৱিমল বুদ্ধি দাতা সুৱিমল-মতি।",
            "অঘ-ৱন-দহন অমল অবিগত গতি, ৱিদ্যা-ৱিনয়-ৱিভৱ-দায়ক কী॥",
            "আৰতী গজবদন ৱিনায়ক কী॥",

            "পিঙ্গলনয়ন, ৱিশাল শুণ্ডধৰ,",
            "ধূম্ৰৱৰ্ণ শুচি ৱজ্ৰাঙ্কুশ-কৰ।",
            "লম্বোদৰ বাধা-ৱিপত্তি-হৰ, সুৰ-ৱন্দিত সব ৱিধি লায়ক কী॥",
            "আৰতী গজবদন ৱিনায়ক কী॥"
          ]
        }
      },
      {
        id: "jai-ganesh2",
        title: "Shree Ganapati",
        lyrics: {
          hi: [
            "॥ आरती श्री गणपति जी ॥",
            "गणपति की सेवा मंगल मेवा, सेवा से सब विघ्न टरैं।",
            "तीन लोक के सकल देवता, द्वार खड़े नित अर्ज करैं॥",
            "गणपति की सेवा मंगल मेवा...॥",

            "रिद्धि-सिद्धि दक्षिण वाम विराजें, अरु आनन्द सों चमर करैं।",
            "धूप-दीप अरू लिए आरती, भक्त खड़े जयकार करैं॥",
            "गणपति की सेवा मंगल मेवा...॥",

            "गुड़ के मोदक भोग लगत हैं, मूषक वाहन चढ्या सरैं।",
            "सौम्य रूप को देख गणपति के, विघ्न भाग जा दूर परैं॥",
            "गणपति की सेवा मंगल मेवा...॥",

            "भादो मास अरु शुक्ल चतुर्थी, दिन दोपारा दूर परैं।",
            "लियो जन्म गणपति प्रभु जी, दुर्गा मन आनन्द भरैं॥",
            "गणपति की सेवा मंगल मेवा...॥",

            "अद्भुत बाजा बजा इन्द्र का, देव बंधु सब गान करैं।",
            "श्री शंकर के आनन्द उपज्या, नाम सुन्यो सब विघ्न टरैं॥",
            "गणपति की सेवा मंगल मेवा...॥",

            "आनि विधाता बैठे आसन, इन्द्र अप्सरा नृत्य करैं।",
            "देख वेद ब्रह्मा जी जाको, विघ्न विनाशक नाम धरैं॥",
            "गणपति की सेवा मंगल मेवा...॥",

            "एकदन्त गजवदन विनायक, त्रिनयन रूप अनूप धरैं।",
            "पगथंभा सा उदर पुष्ट है, देव चन्द्रमा हास्य करैं॥",
            "गणपति की सेवा मंगल मेवा...॥",

            "दे शराप श्री चन्द्रदेव को, कलाहीन तत्काल करैं।",
            "चौदह लोक में फिरें गणपति, तीन लोक में राज्य करैं॥",
            "गणपति की सेवा मंगल मेवा...॥",

            "उठि प्रभात जप करैं ध्यान, कोई ताके कारज सर्व सरैं।",
            "पूजा काल आरती गावैं, ताके शिर यश छत्र फिरैं॥",
            "गणपति की सेवा मंगल मेवा...॥",

            "गणपति की पूजा पहले करने से, काम सभी निर्विघ्न सरैं।",
            "सभी भक्त गणपति जी के, हाथ जोड़कर स्तुति करैं॥",
            "गणपति की सेवा मंगल मेवा...॥"
          ],

          en: [
            "॥ Aarti Shri Ganapati Ji ॥",
            "Ganapati Ki Seva Mangala Meva, Seva Se Saba Vighna Tarain।",
            "Tina Loka Ke Sakala Devata, Dvara Khade Nita Arja Karain॥",
            "Ganapati Ki Seva Mangala Meva...॥",

            "Riddhi-Siddhi Dakshina Vama Virajen, Aru Ananda Son Chamara Karain।",
            "Dhupa-Dipa Aru Liye Aarti, Bhakta Khade Jayakara Karain॥",
            "Ganapati Ki Seva Mangala Meva...॥",

            "Guda Ke Modaka Bhoga Lagata Hain, Mushaka Vahana Chadhya Sarain।",
            "Saumya Rupa Ko Dekha Ganapati Ke, Vighna Bhaga Ja Dura Parain॥",
            "Ganapati Ki Seva Mangala Meva...॥",

            "Bhado Masa Aru Shukla Chaturthi, Dina Dopara Dura Parain।",
            "Liyo Janma Ganapati Prabhu Ji, Durga Mana Ananda Bharain॥",
            "Ganapati Ki Seva Mangala Meva...॥",

            "Adbhuta Baja Baja Indra Ka, Deva Bandhu Saba Gana Karain।",
            "Shri Shankara Ke Ananda Upajya, Nama Sunyo Saba Vighna Tarain॥",
            "Ganapati Ki Seva Mangala Meva...॥",

            "Ani Vidhata Baithe Asana, Indra Apsara Nritya Karain।",
            "Dekha Veda Brahma Ji Jako, Vighna Vinashaka Nama Dharain॥",
            "Ganapati Ki Seva Mangala Meva...॥",

            "Ekadanta Gajavadana Vinayaka, Trinayana Rupa Anupa Dharain।",
            "Pagathambha Sa Udara Pushta Hai, Deva Chandrama Hasya Karain॥",
            "Ganapati Ki Seva Mangala Meva...॥",

            "De Sharapa Shri Chandradeva Ko, Kalahina Tatkala Karain।",
            "Chaudaha Loka Mein Phirein Ganapati, Tina Loka Mein Rajya Karain॥",
            "Ganapati Ki Seva Mangala Meva...॥",

            "Uthi Prabhata Japa Karain Dhyana, Koi Take Karaja Sarva Sarain।",
            "Puja Kala Aarti Gavain, Take Shira Yasha Chhatra Phirain॥",
            "Ganapati Ki Seva Mangala Meva...॥",

            "Ganapati Ki Puja Pahale Karane Se, Kama Sabhi Nirvighna Sarain।",
            "Sabhi Bhakta Ganapati Ji Ke, Hatha Jodakara Stuti Karain॥",
            "Ganapati Ki Seva Mangala Meva...॥"
          ],

          bn: [
            "॥ আৰতী শ্ৰী গণপতি জী ॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা, সেৱা সে সব ৱিঘ্ন টৰৈং।",
            "তীন লোক কে সকল দেৱতা, দ্ৱাৰ খড়ে নিত অৰ্জ কৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥",

            "ৰিদ্ধি-সিদ্ধি দক্ষিণ ৱাম ৱিৰাজেং, অৰু আনন্দ সোং চমৰ কৰৈং।",
            "ধূপ-দীপ অৰূ লিএ আৰতী, ভক্ত খড়ে জয়কাৰ কৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥",

            "গুড় কে মোদক ভোগ লগত হৈং, মূষক ৱাহন চঢ্যা সৰৈং।",
            "সৌম্য ৰূপ কো দেখ গণপতি কে, ৱিঘ্ন ভাগ জা দূৰ পৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥",

            "ভাদো মাস অৰু শুক্ল চতুৰ্থী, দিন দোপাৰা দূৰ পৰৈং।",
            "লিয়ো জন্ম গণপতি প্ৰভু জী, দুৰ্গা মন আনন্দ ভৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥",

            "অদ্ভুত বাজা বজা ইন্দ্ৰ কা, দেৱ বন্ধু সব গান কৰৈং।",
            "শ্ৰী শঙ্কৰ কে আনন্দ উপজ্যা, নাম সুন্যো সব ৱিঘ্ন টৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥",

            "আনি ৱিধাতা বৈঠে আসন, ইন্দ্ৰ অপ্সৰা নৃত্য কৰৈং।",
            "দেখ ৱেদ ব্ৰহ্মা জী জাকো, ৱিঘ্ন ৱিনাশক নাম ধৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥",

            "একদন্ত গজৱদন ৱিনায়ক, ত্ৰিনয়ন ৰূপ অনূপ ধৰৈং।",
            "পগথম্ভা সা উদৰ পুষ্ট হৈ, দেৱ চন্দ্ৰমা হাস্য কৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥",

            "দে শৰাপ শ্ৰী চন্দ্ৰদেৱ কো, কলাহীন তৎকাল কৰৈং।",
            "চৌদহ লোক মেং ফিৰেং গণপতি, তীন লোক মেং ৰাজ্য কৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥",

            "উঠি প্ৰভাত জপ কৰৈং ধ্যান, কোঈ তাকে কাৰজ সৰ্ৱ সৰৈং।",
            "পূজা কাল আৰতী গাৱৈং, তাকে শিৰ যশ ছত্ৰ ফিৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥",

            "গণপতি কী পূজা পহলে কৰনে সে, কাম সভী নিৰ্ৱিঘ্ন সৰৈং।",
            "সভী ভক্ত গণপতি জী কে, হাত জোড়কৰ স্তুতি কৰৈং॥",
            "গণপতি কী সেৱা মঙ্গল মেৱা...॥"
          ]
        }
      }
    ]
  },

  durga: {
    name: "Goddess Durga",
    image: "/assets/gods/durga.png",

    aratis: [
      {
        id: "ambe",
        title: "Ambe Tu Hai Jagdambe",
        lyrics: {
          hi: ["अम्बे तू है जगदम्बे काली"],
          en: ["Ambe Tu Hai Jagdambe Kali"],
          bn: ["অম্বে তুমি জগদম্বে কালী"]
        }
      }
    ]
  }
};
